import { UserObject } from '@client/graphql/__generated__/types';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '~/services/main/contexts/AppContext';
import { StytchLoginForm } from './StytchLoginForm';

interface LoginFormProps {
  onLogin: (user: UserObject) => void | Promise<void>;
}

export const LoginForm = ({ onLogin }: LoginFormProps) => {
  const navigate = useNavigate();
  const { refetchUser } = useAppContext();

  const onStytchLogin = useCallback(
    async (user: UserObject) => {
      await refetchUser();

      if (user && user.roles.length === 0) {
        navigate('/auth/signup', { replace: true });
      }

      if (user.roles.length > 0) {
        return await onLogin(user);
      }
    },
    [onLogin, navigate, refetchUser]
  );

  return <StytchLoginForm onLogin={onStytchLogin} />;
};
